import * as React from "react";
import { Field, reduxForm } from "redux-form";
import FormElements from "../../FormElements";

const Button = FormElements.Buttons.Primary;

interface Props {
    onSubmit: (fields: Fields) => void;
    onCancel: () => void;
    handleSubmit?: () => void;
}

interface State {
}

export interface Fields {
    summary: string;
    medicine: string;
}

const s = require("./AddHistoryItem.scss");

class AddHistoryItem extends React.Component<Props, State> {
    render(): JSX.Element {
        return (
            <form className={s.form} onSubmit={this.props.handleSubmit}>
                <label className={s.label}>
                    <div className={s.caption}>Medicamento em uso:</div>

                    <Field
                        name="medicine"
                        component="input"
                        props={{
                            placeholder: "Nome do medicamento em uso..."
                        }}
                    />
                </label>

                <label className={s.label}>
                    <div className={s.caption}>Resumo do caso:</div>

                    <Field
                        name="summary"
                        component="input"
                        props={{
                            placeholder: "Escreva o resumo do caso..."
                        }}
                    />
                </label>

                <div className={s.buttons}>
                    <Button type="reset" onClick={this.props.onCancel}>Cancelar</Button>
                    <Button>Salvar</Button>
                </div>
            </form>
        );
    }
}

export default reduxForm({
  form: "AddHistoryItem"
})(AddHistoryItem);



// WEBPACK FOOTER //
// ./src/components/Forms/AddHistoryItem/index.tsx